import type { Rule } from '@tunasong/schemas'

/** Human event labels. Focus keys (`entered`/`left`) MUST render as prose, never raw (ADR microcopy). */
const eventLabels: Record<string, string> = {
  entered: 'When opened',
  left: 'When closed',
  created: 'created',
  updated: 'updated',
  moved: 'moved',
  tagged: 'tagged',
}

const actionLabels: Record<string, string> = {
  'convert-entity-to-song': 'Convert it to a Song',
}

const humanize = (id: string): string => id.replace(/[-_]/g, ' ').replace(/\b\w/g, char => char.toUpperCase())

export interface RuleSentence {
  eventLabel: string
  entityType?: string
  tag?: string
  actionLabel: string
  isFocus: boolean
}

/** Break a rule into the human parts the card renders as a sentence. */
export const describeRule = (rule: Rule): RuleSentence => {
  const typeCondition = rule.conditions.find(condition => condition.kind === 'type')
  const tagCondition = rule.conditions.find(condition => condition.kind === 'tag')
  const firstAction = rule.actions[0]
  return {
    eventLabel: eventLabels[rule.event] ?? rule.event,
    entityType: typeCondition?.kind === 'type' ? typeCondition.entityType : undefined,
    tag: tagCondition?.kind === 'tag' ? tagCondition.tag : undefined,
    actionLabel: firstAction ? (actionLabels[firstAction.commandId] ?? humanize(firstAction.commandId)) : '',
    isFocus: rule.event === 'entered' || rule.event === 'left',
  }
}
